<script>
export default {
  props: ['stableData'],
  data () {
    return {
      option1: {
        tooltip: {
          trigger: 'axis',
          formatter: function (params) {
            var relVal = params[0].name
            for (var i = 0, l = params.length; i < l; i++) {
              relVal += '<br/>' + params[i].marker + params[i].seriesName + `&nbsp;&nbsp;&nbsp;&nbsp;` + params[i].value + '%'
            }
            return relVal
          }
        },
        legend: {
          data: ['Ua', 'Ub', 'Uc'],
          // right: 30,
          top: 20,
          formatter: ''
        },
        grid: {
          y2: 20
        },
        toolbox: {
          show: true,
          feature: {}
        },
        calculable: true,
        xAxis: [{
          type: 'category',
          data: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50]
        }],
        yAxis: [{
          type: 'value',
          axisLabel: {
            formatter: '{value} %'
          }
        }],
        series: [{
          name: 'Ua',
          type: 'bar',
          showSymbol: false,
          itemStyle: {
            color: '#fccc00'
          },
          data: this.stableData ? this.stableData.fft_ua : []
        }, {
          name: 'Ub',
          type: 'bar',
          showSymbol: false,
          itemStyle: {
            color: '#009800'
          },
          data: this.stableData ? this.stableData.fft_ub : []
        }, {
          name: 'Uc',
          type: 'bar',
          showSymbol: false,
          itemStyle: {
            color: '#ff0000'
          },
          data: this.stableData ? this.stableData.fft_uc : []
        }
        ]
      },
      option2: {
        tooltip: {
          trigger: 'axis',
          formatter: function (params) {
            var relVal = params[0].name
            for (var i = 0, l = params.length; i < l; i++) {
              relVal += '<br/>' + params[i].marker + params[i].seriesName + `&nbsp;&nbsp;&nbsp;&nbsp;` + params[i].value + '%'
            }
            return relVal
          }
        },
        legend: {
          data: ['Uab', 'Ubc', 'Uca'],
          // right: 30,
          top: 20,
          formatter: ''
        },
        grid: {
          y2: 20
        },
        toolbox: {
          show: true,
          feature: {}
        },
        calculable: true,
        xAxis: [{
          type: 'category',
          data: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50]
        }],
        yAxis: [{
          type: 'value',
          axisLabel: {
            formatter: '{value} %'
          }
        }],
        series: [{
          name: 'Uab',
          type: 'bar',
          showSymbol: false,
          itemStyle: {
            color: '#fccc00'
          },
          data: this.stableData ? this.stableData.fft_uab : []
        }, {
          name: 'Ubc',
          type: 'bar',
          showSymbol: false,
          itemStyle: {
            color: '#009800'
          },
          data: this.stableData ? this.stableData.fft_ubc : []
        }, {
          name: 'Uca',
          type: 'bar',
          showSymbol: false,
          itemStyle: {
            color: '#ff0000'
          },
          data: this.stableData ? this.stableData.fft_uca : []
        }
        ]
      },
      option3: {
        tooltip: {
          trigger: 'axis',
          formatter: function (params) {
            var relVal = params[0].name
            for (var i = 0, l = params.length; i < l; i++) {
              relVal += '<br/>' + params[i].marker + params[i].seriesName + `&nbsp;&nbsp;&nbsp;&nbsp;` + params[i].value + '%'
            }
            return relVal
          }
        },
        legend: {
          data: ['Ia', 'Ib', 'Ic', 'In'],
          // right: 30,
          top: 20,
          formatter: ''
        },
        grid: {
          y2: 20
        },
        toolbox: {
          show: true,
          feature: {}
        },
        calculable: true,
        xAxis: [{
          type: 'category',
          data: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50]
        }],
        yAxis: [{
          type: 'value',
          axisLabel: {
            formatter: '{value} %'
          }
        }],
        series: [{
          name: 'Ia',
          type: 'bar',
          showSymbol: false,
          itemStyle: {
            color: '#fccc00'
          },
          data: this.stableData ? this.stableData.fft_ia : []
        }, {
          name: 'Ib',
          type: 'bar',
          showSymbol: false,
          itemStyle: {
            color: '#009800'
          },
          data: this.stableData ? this.stableData.fft_ib : []
        }, {
          name: 'Ic',
          type: 'bar',
          showSymbol: false,
          itemStyle: {
            color: '#ff0000'
          },
          data: this.stableData ? this.stableData.fft_ic : []
        }, {
          name: 'In',
          type: 'bar',
          showSymbol: false,
          itemStyle: {
            color: '#00a1f5'
          },
          data: this.stableData ? this.stableData.fft_in : []
        }
        ]
      },
      chart: {},
      posSelectOptions: [{
        value: 1,
        label: '相电压'
      }, {
        value: 2,
        label: '线电压'
      }, {
        value: 3,
        label: '电流'
      }],
      posSelectValue: 1,
      showTypeSelectOptions: [{
        value: 1,
        label: '频谱图'
      }, {
        value: 2,
        label: '频谱表'
      }],
      showTypeSelectValue: 1,
      showRms: {},
      showThd: {},
      showFft: []
    }
  },
  watch: {
    posSelectValue (val) {
      this.Chart.clear()
      this.setValue(val)
    }
  },
  mounted () {
    this.Chart = this.$echarts.init(document.getElementById('options'))
    this.setValue(this.posSelectValue)
  },
  methods: {
    setValue (val) {
      if (val === 1) {
        // this.showRms = {
        //   a: Number(this.stableData ? this.stableData.ua_rms : 0).toFixed(1) + 'V',
        //   b: Number(this.stableData ? this.stableData.ub_rms : 0).toFixed(1) + 'V',
        //   c: Number(this.stableData ? this.stableData.uc_rms : 0).toFixed(1) + 'V'
        // }
        // this.showThd = {
        //   a: Number(this.stableData ? this.stableData.thd_ua_r : 0).toFixed(1),
        //   b: Number(this.stableData ? this.stableData.thd_ub_r : 0).toFixed(1),
        //   c: Number(this.stableData ? this.stableData.thd_uc_r : 0).toFixed(1)
        // }
        // this.showFft = this.stableData ? this.stableData.fft_ua : 0
        this.Chart.setOption(this.option1)
      } else if (val === 2) {
        // this.showRms = {
        //   a: Number(this.stableData ? this.stableData.uab_rms : 0).toFixed(1) + 'V',
        //   b: Number(this.stableData ? this.stableData.ubc_rms : 0).toFixed(1) + 'V',
        //   c: Number(this.stableData ? this.stableData.uca_rms : 0).toFixed(1) + 'V'
        // }
        // this.showThd = {
        //   a: Number(this.stableData ? this.stableData.thd_uab_r : 0).toFixed(1),
        //   b: Number(this.stableData ? this.stableData.thd_ubc_r : 0).toFixed(1),
        //   c: Number(this.stableData ? this.stableData.thd_uca_r : 0).toFixed(1)
        // }
        // this.showFft = this.stableData ? this.stableData.fft_ua : 0
        this.Chart.setOption(this.option2)
      } else if (val === 3) {
        // this.showRms = {
        //   a: Number(this.stableData ? this.stableData.ia_rms : 0).toFixed(1) + 'A',
        //   b: Number(this.stableData ? this.stableData.ib_rms : 0).toFixed(1) + 'A',
        //   c: Number(this.stableData ? this.stableData.ic_rms : 0).toFixed(1) + 'A',
        //   n: Number(this.stableData ? this.stableData.in_rms : 0).toFixed(1) + 'A'
        // }
        // this.showThd = {
        //   a: Number(this.stableData ? this.stableData.thd_ia_r : 0).toFixed(1),
        //   b: Number(this.stableData ? this.stableData.thd_ib_r : 0).toFixed(1),
        //   c: Number(this.stableData ? this.stableData.thd_ic_r : 0).toFixed(1),
        //   n: Number(this.stableData ? this.stableData.thd_in_r : 0).toFixed(1)
        // }
        this.Chart.setOption(this.option3)
      }
    }
  }
}
</script>

<template>
  <div class="pg">
    <div class="dataItems">
      <div class="title">谐波频谱图</div>

      <div style="display: flex; flex-wrap: wrap; height: 35px; line-height: 35px; margin-bottom: 10px">
        <div style="display: flex; width: 100%;">
          <div
            style="display: flex; align-items: center; margin-left: 20px;">
            <div style="width: 80px; text-align: left;">电气量</div>

            <div style="width: 120px; font-size: 20px">
              <el-select v-model="posSelectValue" placeholder="请选择" size="20px">
                <el-option
                  v-for="item in posSelectOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </div>

<!--          <div-->
<!--            style="display: flex; align-items: center; margin-left: 10px">-->
<!--            <div style="width: 80px">有效值</div>-->
<!--            <el-button style="width: 130px; margin-left: 10px; font-size: 20px;">-->
<!--              <div style="display: flex">-->
<!--                <div style="width: 40%; margin-right: 5px">A相</div>-->
<!--                <div style="width: 60%; text-align: center">{{ showRms.a }}</div>-->
<!--              </div>-->
<!--            </el-button>-->
<!--            <el-button style="width: 130px; font-size: 20px;">-->
<!--              <div style="display: flex">-->
<!--                <div style="width: 40%; margin-right: 5px">B相</div>-->
<!--                <div style="width: 60%; text-align: center">{{ showRms.b }}</div>-->
<!--              </div>-->
<!--            </el-button>-->
<!--            <el-button style="width: 130px; font-size: 20px;">-->
<!--              <div style="display: flex">-->
<!--                <div style="width: 40%; margin-right: 5px">C相</div>-->
<!--                <div style="width: 60%; text-align: center">{{ showRms.c }}</div>-->
<!--              </div>-->
<!--            </el-button>-->
<!--            <el-button style="width: 130px; font-size: 20px;" v-if="posSelectValue===3">-->
<!--              <div style="display: flex">-->
<!--                <div style="width: 40%; margin-right: 5px">N相</div>-->
<!--                <div style="width: 60%; text-align: center">{{ showRms.n }}</div>-->
<!--              </div>-->
<!--            </el-button>-->
<!--          </div>-->
        </div>
      </div>
<!--      <div-->
<!--        style="display: flex; flex-wrap: wrap; height: 35px; line-height: 35px; margin-top: 10px; margin-bottom: 10px;">-->

<!--        <div-->
<!--          style="width: 130px; display: flex; align-items: center; margin-left: 20px; margin-top: -15px; border-right: 1px solid black">-->
<!--        </div>-->
<!--        <div-->
<!--          style="display: flex; align-items: center; margin-left: 10px">-->
<!--          <div style="width: 80px">THD-R</div>-->
<!--          <el-button style="width: 130px; margin-left: 10px; font-size: 20px;">-->
<!--            <div style="display: flex">-->
<!--              <div style="width: 40%; margin-right: 5px">A相</div>-->
<!--              <div style="width: 60%; text-align: center">{{ showThd.a }}%</div>-->
<!--            </div>-->
<!--          </el-button>-->
<!--          <el-button style="width: 130px; font-size: 20px;">-->
<!--            <div style="display: flex">-->
<!--              <div style="width: 40%; margin-right: 5px">B相</div>-->
<!--              <div style="width: 60%; text-align: center">{{ showThd.b }}%</div>-->
<!--            </div>-->
<!--          </el-button>-->
<!--          <el-button style="width: 130px; font-size: 20px;">-->
<!--            <div style="display: flex">-->
<!--              <div style="width: 40%; margin-right: 5px">C相</div>-->
<!--              <div style="width: 60%; text-align: center">{{ showThd.c }}%</div>-->
<!--            </div>-->
<!--          </el-button>-->
<!--          <el-button style="width: 130px; font-size: 20px;" v-if="posSelectValue===3">-->
<!--            <div style="display: flex">-->
<!--              <div style="width: 40%; margin-right: 5px">N相</div>-->
<!--              <div style="width: 60%; text-align: center">{{ showThd.n }}%</div>-->
<!--            </div>-->
<!--          </el-button>-->
<!--        </div>-->
<!--      </div>-->
      <div style="height: calc(100% - 125px);">
        <div id="options" style="height: 100%; width: 100%; border-top: 1px solid black"
             v-show="showTypeSelectValue===1"></div>
      </div>
    </div>
  </div>
</template>

<style scoped>
@import "../../../assets/css/stable.css";

.dataName {
  width: 10%;
}

.dataValue {
  width: 10%;
//border-right: 1px solid black;
}

.dataTitle {
  height: 30px;
}

.dataNvItem {
  height: calc((100% - 70px) / 10);
}

.el-input--suffix .el-input__inner {
  font-size: 20px !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/Stable/ThdChart/ThdChart.vue